<template>
  <div
    class="newsletter"
    id="subscribirse"
    :style="`background-image: url(${require('@/assets/newsletter/newsletter-background.png')})`"
  >
    <b-container fluid="md">
      <b-row align-h="center">
        <b-col md="5">
          <h4 v-if="!success">Suscribite a nuestro <b>newsletter</b>.</h4>
          <h4 v-else>¡Gracias por subscribirte!</h4>
        </b-col>
        <b-col md="5">
          <b-form @submit="onSubmit">
            <b-input-group class="d-block d-sm-flex">
              <b-form-input
                placeholder="Ingresa tu email"
                v-model="email"
                type="email"
                :state="emailValidation"
                @input="hotValidate"
                @blur="validate"
                class="rounded-0 my-3 my-sm-0"
              ></b-form-input>
              <b-input-group-append>
                <b-overlay
                  :show="loading"
                  opacity="0.6"
                  spinner-small
                  spinner-variant="light"
                  class="d-inline-block mx-auto m-sm-0"
                >
                  <b-button
                    @click="onSubmit"
                    :disabled="!emailValidation"
                    class="bg-color-darken-1 rounded-0"
                  >
                    Subscribirse
                  </b-button>
                </b-overlay>
              </b-input-group-append>
              <b-form-invalid-feedback :state="emailValidation">
                Ups, parece que no has escrito bien el email
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { db } from "../services/firebase";

export default {
  name: "Newsletter",
  data() {
    return {
      email: "",
      emailValidation: null,
      loading: false,
      success: false
    };
  },
  methods: {
    onSubmit() {
      if (this.emailValidation) {
        this.loading = true;
        db.collection("newsletter")
          .doc()
          .set({
            emai: this.email,
            date: new Date()
          })
          .then(() => {
            setTimeout(() => {
              this.loading = false;
              this.success = true;
              this.email = "";
              this.emailValidation = null;
              setTimeout(() => {
                this.success = false;
              }, 3000);
            }, 1000);
          })
          .catch((e) => {
            throw new Error("Error at save email: " + e);
          });
      }
    },
    validate() {
      const regExp = /\S+@\S+\.\S+/;
      if (this.email) {
        this.emailValidation = regExp.test(this.email);
      }
    },
    hotValidate() {
      const regExp = /\S+@\S+\.\S+/;
      if (this.email && regExp.test(this.email)) {
        this.emailValidation = true;
      }
    }
  }
};
</script>

<style scoped lang="sass">
.newsletter
  margin: 0 4rem;
  padding: 4rem 2rem
  background-position: center center
  background-repeat: no-repeat
  background-size: cover
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08)
  // border-radius: 83px;
  @media screen and (max-width: 502px)
    margin: 0
    padding: 4rem 1rem
    background-position-x: 94%
    text-align: center
    input
      text-align: center
    button
      margin: 0 auto
</style>
